export const outreach = [
  'Building bridges event in collaboration with the Northeastern Center for STEM Education. '
  + 'The event was an informational exposition designed for younger students to learn about '
  + 'STEM topics.',

  'At last year’s event 103 students from 32 schools and 5 states attendedand 100%'
  + 'of surveyed students would recommend the event to others interested inlearning more about STEM.',

  'While at the building bridges event, SEDS showed off our different projects'
  + 'and helped answer questions about what it is like working on STEM projects,'
  + 'particularly in the area of space technology.',

  'Showcased the Rover to 40+ local high school students from lower-income communities through an '
  + 'event organized by the Center for STEM Education at Northeastern, '
  + 'where some students got to drive the Rover around campus.',

  'Represented Northeastern’s Institute for Experiential Robotics at the '
  + 'MassRobotics Block Party and demonstrated the Rover to thousands of professionals in the robotics space.',

  'Showcased the Mars rover at the kickoff event for Mass STEM Week, where we showcased '
  + 'the rover to over 50 local high school students, as well as Former Massachusetts Governor '
  + 'Charlie Baker. This was an extremely high profile event, where Governor Baker and '
  + 'President Aoun discussed the importance of STEM education and experiential learning.',

  'Hosted an exhibit at the Museum of Science (MOS) for Computer Science Education Weekend, '
  + 'where we demonstrated our rover to thousands of grade-school students and their '
  + 'families in hopes of inspiring them to become future engineers and scientists.',

  'Attended an event hosted by Roxbury Robotics where we showcased our Rover to underprivileged students.'
];